module.exports = __webpack_public_path__ + "static/media/finallogo (2).8dd1b3e6.png";